export const normalizeEmail = (raw: string) => {
  const trimmed = raw.trim();
  const [local = "", domain = ""] = trimmed.split("@");
  return `${local}@${domain.toLowerCase()}`;
}

export const isValidEmail = (emailRaw: string) => {
  const email = normalizeEmail(emailRaw);

  if (email.length > 254) return false;

  const re = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  if (!re.test(email)) return false;

  const [local, domain] = email.split("@");
  if (!local || !domain) return false;

  if (local.length > 64) return false;
  if (domain.length > 255) return false;
  if (local.startsWith(".") || local.endsWith(".")) return false;
  if (local.includes("..")) return false;   // 로컬 연속 점 방지
  if (domain.includes("..")) return false;  // 도메인 연속 점 방지
  if (!domain.includes(".")) return false;  // TLD 최소 확인

  return true;
}
